module.exports = __webpack_public_path__ + "static/media/how-it-works.df264d36.gif";